/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import PressmarkSketch from "../pressmarks/PressmarkSketch";
import AddNote from "../notes/AddNote";
import NoteList from "../notes/NotesList";
import Layout from "../layout/Layout";
import Spinner from "../spinner/Spinner";

const button = css`
  background-color: #f7c02d;
  border: none;
  outline: none;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  margin-top: 20px;
  &:hover {
    cursor: pointer;
    color: #fff;
    transition: all 0.3s;
    border: 1px solid #fff;
  }
`;

class CalculatePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      billetweight: "",
      channel: "",
      presslength: "",
      billetlength: "",
      metalyield: "",
      error: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (value > 0) {
      this.setState({
        [name]: Number(value)
      });
    } else {
      this.setState({
        [name]: ""
      });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    let billetlength = Math.round(
      ((this.state.presslength *
        this.state.channel *
        this.props.pressmark.weight) /
        this.state.billetweight) *
        0.001 +
        25
    );

    let profilelength;
    if (this.state.presslength > 57000 && this.state.billetweight === 0.0983) {
      profilelength = this.state.presslength - 4000;
    } else if (
      this.state.presslength > 44000 &&
      this.state.billetweight < 0.0983
    ) {
      profilelength = this.state.presslength - 4000;
    } else profilelength = this.state.presslength - 2000;

    let metalyield =
      (profilelength * this.state.channel * this.props.pressmark.weight) /
      (billetlength * this.state.billetweight) /
      10;
    this.setState({
      billetlength,
      metalyield
    });

    if (
      this.state.billetweight === "" ||
      this.state.channel === "" ||
      this.state.presslength === ""
    ) {
      this.setState({
        error: "Пожалуйста введите корректные данные."
      });
    } else {
      this.setState({
        error: ""
      });
    }
  }

  render() {
    const notes = this.props.auth.uid ? (
      <div>
        <NoteList notes={this.props.notes} />
        <AddNote
          pressmark={this.props.pressmark.pressmark}
          pressmarkId={this.props.pressmark.id}
        />
      </div>
    ) : (
      <p>
        Пожалуйста зарегистрируйтесь или войдите чтобы просматривать и добавлять
        замечания.
      </p>
    );

    return (
      <Layout>
        {!isLoaded(this.props.pressmark) ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row justify-content-center">
              <h5 className="text-center w-100 mt-5 px-2">
                Рассчитать длину заготовки для профиля{" "}
                {this.props.pressmark.pressmark}
                <PressmarkSketch
                  buttonLabel={"эскиз"}
                  className="modal-lg"
                  title={this.props.pressmark.pressmark}
                  url={this.props.pressmark.imgUrl}
                />
              </h5>
              <div className="col-8 col-sm-6 col-lg-4 mt-4">
                <form onSubmit={this.handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="billetweight">
                      Выберите диаметр заготовки, мм
                    </label>
                    <select
                      required
                      value={this.state.billetweight}
                      name="billetweight"
                      onChange={this.handleChange}
                      className="form-control"
                      id="billetweight"
                    >
                      <option value="" disabled>
                        ...
                      </option>
                      <option value="0.0983">215</option>
                      <option value="0.0445">145</option>
                      <option value="0.06702">178</option>
                    </select>
                  </div>
                  <div className="form-group mt-5">
                    <label htmlFor="channel">Введите число каналов</label>
                    <input
                      type="number"
                      value={this.state.channel}
                      name="channel"
                      onChange={this.handleChange}
                      className="form-control"
                      min="1"
                      max="12"
                      id="channel"
                      placeholder="2"
                    />
                  </div>
                  <div className="form-group mt-5">
                    <label htmlFor="presslength">
                      Введите прессуемую длину, мм
                    </label>
                    <input
                      type="number"
                      value={this.state.presslength}
                      name="presslength"
                      onChange={this.handleChange}
                      className="form-control"
                      min="1000"
                      max="200000"
                      id="presslength"
                      placeholder="44000"
                    />
                  </div>
                  <p>{this.state.error}</p>
                  <button
                    css={button}
                    type="submit"
                  >
                    рассчитать
                  </button>
                </form>
                <h6 className="text-center mt-5">
                  Длина заготовки:{" "}
                  {this.state.billetlength > 200 ? this.state.billetlength : 0}{" "}
                  мм
                </h6>
                <h6 className="text-center mb-5">
                  Выход годного:{" "}
                  {this.state.metalyield > 50
                    ? this.state.metalyield.toFixed(2)
                    : 0}{" "}
                  %
                </h6>
              </div>
              <div className="col-md-auto" />
              <div className="col-12 col-lg-6 mt-4">
                <h5 className="text-center">Замечания</h5>
                {notes}
              </div>
            </div>
          </div>
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    pressmark: state.firestore.ordered.pressmarks
      ? state.firestore.ordered.pressmarks.find(pressmark => {
          return pressmark.id === props.match.params.id;
        })
      : [],
    notes: state.firestore.ordered.notes
      ? state.firestore.ordered.notes.filter(note => {
          return note.pressmarkId === props.match.params.id;
        })
      : [],
    auth: state.firebase.auth
  };
};

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  firestoreConnect([
    { collection: "pressmarks" },
    { collection: "notes", orderBy: ["created", "desc"] }
  ])
)(CalculatePage);
